import { render, staticRenderFns } from "./unifyAvatar.vue?vue&type=template&id=9ec69b3e&scoped=true"
import script from "./unifyAvatar.vue?vue&type=script&lang=js"
export * from "./unifyAvatar.vue?vue&type=script&lang=js"
import style0 from "./unifyAvatar.vue?vue&type=style&index=0&id=9ec69b3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec69b3e",
  null
  
)

export default component.exports